import React, { forwardRef, useImperativeHandle, useState } from 'react'
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, FormInputText } from '../Form';
import * as yup from "yup";
import { StandardConst } from '../../Services/StandardConst';
import { WebService } from '../../Services/WebService';
import { useDispatch, useSelector } from "react-redux"


const AddEditSkills = (props, ref) => {
    const [show, setShow] = useState(false);
    const [interviewTypeData, setInterviewTypeData] = useState({});
    const CompanyInfo = useSelector((s) => s.auth.CompanyInfo);
    const Roles = useSelector((s) => s.auth.AssignRole ?? {});
    const isSuperAdmin = Roles?.some(element => element === StandardConst.SystemRole.SuperAdmin);
    const dispatch = useDispatch();
    useImperativeHandle(ref, () => ({
        openModal: async (id) => {
            setShow(true);
            if (id > 0) {
                setShow(false);
                await fetchEditValue(id);
                setShow(true);
            }
        },
    }));

    const fetchEditValue = async (id) => {
        await WebService({
            endPoint: `CommonUtility/Edit/staticskill?SkillId=${id || 0}`,
            dispatch,
        }).then((c) => (c.length > 0 ? setInterviewTypeData(c[0]) : {}));
    }

    const handleClose = () => {
        setShow(false)
        setInterviewTypeData({});
    };

    const schema = yup
        .object()
        .shape({
            SkillName: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
            // Status: yup.string().trim().required(requiredMessage),
        })
        .required();

    const onSubmit = async (data) => {
        if (data.SkillId === undefined) {
            await WebService({
                endPoint: "CommonUtility/staticskill",
                body: data,
                dispatch,
            });
        } else {
            await WebService({
                endPoint: `CommonUtility/staticskill?SkillId=${data.SkillId}`,
                method: "PUT",
                body: data,
                dispatch,
            });
        }
        handleClose();
        props.callBackEvent();
    }

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {(interviewTypeData.StaticInterviewTypeId || 0) === 0
                        ? "Add Skill"
                        : "Edit Skill"
                    }
                </Modal.Title>
            </Modal.Header>
            <Form
                defaultValues={interviewTypeData}
                onSubmit={onSubmit}
                validationSchema={schema}
            >
                <Modal.Body className="p-4">
                    <div className="row">
                        <div className="col-md-12">
                            <FormInputText
                                label="skill Name"
                                name="SkillName"
                                type="text"
                                isRequired="true"
                            />
                        </div>
                      
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnAccessLevelSubmit" variant="outline-primary" type="submit">
                        {" "}
                        {(interviewTypeData && interviewTypeData.StaticInterviewTypeId || 0) === 0
                            ? "Submit"
                            : "Save Changes"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default forwardRef(AddEditSkills);